import {
  DeleteUserInviteMutation,
  DeleteUserInviteMutationVariables,
  useDeleteUserInviteMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import { useCallback } from "react";

export default function useDeleteUserInvite() {
  const [mutation, { data, loading, error }] = useDeleteUserInviteMutation({
    refetchQueries: ["getOrganizationUsers", "customGetOrganizationUsers"],
  });

  const [deleteUserInvite, context] = useBitumioMutation(
    {
      mutation,
      data,
      loading,
      error,
      key: "deleteUserInvite",
    },
    {
      successMessage: "User invite deleted successfully",
      failureMessage: "Failed to delete user invite",
      showValidationErrors: true,
    }
  );

  const deleteUserInviteFn = useCallback(
    (values: DeleteUserInviteMutationVariables) => {
      return deleteUserInvite({ variables: values });
    },
    [mutation]
  );

  return [deleteUserInviteFn, context] as const;
}
